import { render, staticRenderFns } from "./Categoria.vue?vue&type=template&id=186a1fa6&lang=pug"
import script from "./Categoria.vue?vue&type=script&lang=js"
export * from "./Categoria.vue?vue&type=script&lang=js"
import style0 from "./Categoria.vue?vue&type=style&index=0&id=186a1fa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports